<script setup lang="ts">
import { globalVar, useGlobals, useSession } from '@/helpers/globals';
import KpButton from './KpButton.vue';
import { reactive, type Ref, ref } from 'vue';
import { AuthLevel, logout } from '@/helpers/auth';
import { appUrl } from '@/helpers/api';
import { Menu, type MenuMethods } from 'primevue';
import { getI18n } from '@/helpers/i18n';
import { useRouter } from 'vue-router';

const session = useSession();
const i18n = getI18n();

const state = reactive({
    loading: false,
});

const usermenu: Ref<MenuMethods | null> = ref(null);

const userBtnItems = [
    {
        label: i18n.t('profil'),
        icon: 'far fa-user',
        command: openProfile
    },
    {
        label: i18n.t('abmelden'),
        icon: 'far fa-right-from-bracket',
        command: doLogout,
    },
];

function onUserbtnClick(event: MouseEvent) {
    usermenu.value?.toggle(event);
}

function openProfile() {
    router.push({ name: 'profile' });
}

async function doLogout() {
    state.loading = true;
    try {
        await logout();
        window.location.href = appUrl('/login');
    } finally {
        state.loading = false;
    }
}

const env = useGlobals().environment;
const router = useRouter();

// TODO: Include user menu on auth
</script>
<template>
    <header class="flex px-1rem align-items-center gap-0_5rem">
        <img
            src="@/assets/images/logo.svg"
            alt="Logo"
            height="48px"
            class="mt-1rem mb-0_5rem mr-0_5rem ml-1_5rem"
            @click="router.push('/')"
        />
        <div class="title flex flex-row flex-grow-1" style="height: 100%">
            <div class="version flex flex-column justify-content-end">V.{{ globalVar('version') }}</div>
            <div v-if="env === 'dev'" class="dev">Development</div>
            <div v-else-if="env === 'int'" class="int">Integration</div>
            <div v-else-if="env === 'test'" class="test">Testumgebung</div>
        </div>
        <div v-if="session.user && session.authLevel === AuthLevel.AUTH_COMPLETE">
            <KpButton
                :label="`${session.user.vorname} ${session.user.nachname}`"
                icon="far fa-chevron-down"
                icon-pos="right"
                @click="onUserbtnClick"
                :loading="state.loading"
            />
            <Menu ref="usermenu" :model="userBtnItems" popup></Menu>
        </div>
        <img src="@/assets/images/wappen_tg_sh.svg" width="80" />
    </header>
</template>
<style lang="css" scoped>
header {
    overflow: auto;
    padding: 0.5rem;
    background-color: var(--p-primary-color);
    background: linear-gradient(270deg, var(--p-primary-400) 0%, var(--p-primary-700) 100%);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    a {
        color: var(--p-primary-contrast-color);
        text-decoration: none;
    }
    .title {
        justify-content: flex-start;
        h2 {
            font-size: 2rem;
            margin: 0;
        }
    }
    .version {
        margin-bottom: 1rem;
        font-size: 0.65rem;
        color: var(--p-primary-contrast-color);
    }
}

.dev {
    color: red;
    margin: auto;
    font-size: 3rem;
    font-weight: 900;
    filter: drop-shadow(0px 0px 5px #000000);
}

.int {
    color: yellow;
    margin: auto;
    font-size: 3rem;
    font-weight: 900;
    filter: drop-shadow(0px 0px 5px #000000);
}

.test {
    color: rgb(255, 157, 0);
    margin: auto;
    font-size: 3rem;
    font-weight: 900;
    filter: drop-shadow(0px 0px 5px #000000);
}
</style>
